import { useState } from 'react';
import { selectorTransversal } from '../../../../dtos/selector';
import { getValoresDominio } from '../../../../services/servicesDominio';
import { Dominios, StatusCode } from '../../../../utils/enums';
import { getInversionistasService } from '../../../endosos/endososMasivos/services/generalServices';
import { getCompanias, getPolizaByName } from '../services/consultarRemesasServices';
import { AxiosResponse } from 'axios';
import { ListResponseDto } from '../../../../dtos/ListResponseDto';

const useConsultarRemesas = () => {
    const [remesas, setRemesas] = useState<any[]>([]);
    const [destinoRemesas, setDestinoRemeses] = useState<selectorTransversal[]>([])
    const [inversionista, setInversionistas] = useState<selectorTransversal[]>([]);
    const [compania, setCompania] = useState<selectorTransversal[]>([]);
    const [poliza, setPoliza] = useState<selectorTransversal[]>([]);

    const consultarDestino = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.DESTINO_REMESAS);
        if (resp.status !== StatusCode.Ok)
            return;

        setDestinoRemeses(resp.data.items);
    }

    const consultarInversionista = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getInversionistasService();
        if (resp.status !== StatusCode.Ok)
            return;
        resp.data.items.sort((a: selectorTransversal, b: selectorTransversal) =>
            a.label.localeCompare(b.label)
        );
        setInversionistas(resp.data.items);
    }

    const consultarCompania = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getCompanias();
        if (resp.status !== StatusCode.Ok)
            return;

        setCompania(resp.data.items);
    }

    const consultarPoliza = async (name: string) => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getPolizaByName(name);
        if (resp.status !== StatusCode.Ok)
            return;

        setPoliza(resp.data.items);
    }
    // Aquí puedes agregar la lógica para consultar remesas

    return {
        remesas,
        destinoRemesas,
        inversionista,
        compania,
        poliza,
        setRemesas,
        consultarDestino,
        consultarInversionista,
        consultarCompania,
        consultarPoliza
    };
};

export default useConsultarRemesas;